/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SenderIdRequestStatus } from './senderIdRequestStatus';
import { SenderIdType } from './senderIdType';


export interface SenderIdRequestBaseModel { 
    creatorId?: string;
    serviceProviderName?: string;
    serviceProviderEmailAddress?: string;
    senderId?: string;
    senderIdType: SenderIdType;
    senderIdTypeName?: string;
    nameOfOrganization?: string;
    serviceProviderCountryOfResidence?: string;
    comments?: string;
    status: SenderIdRequestStatus;
    statusName?: string;
    adminsReasonForDecline?: string;
    dateCreated: Date;
    dateUpdated: Date;
    noOfRetries: number;
    isDeleted: boolean;
    loginURL?: string;
}
